// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2zYvV","selected":"Chip_selected__2sxsv"};